export default __webpack_public_path__ + "static/media/ALAMBRA cyprus.63ad45d6.png";